import { useRouterState } from '@tanstack/react-router';

export function useRouteHash() {
  const hash = useRouterState({
    select: (state) => state.location.hash,
  });

  return hash;
}
